import { useEffect } from 'react';

export function useDocumentTitle(subtitle?: string) {
  useEffect(() => {
    document.title = subtitle ? `snagg · ${subtitle.toLowerCase()}` : 'snagg · see it. want it. snagg it.';
  }, [subtitle]);
}
